import {
  Loading,
  Notify,
  Dialog,
  type QuasarPluginOptions,
} from 'quasar';
import {markRaw, type Component} from 'vue';
import SpinnerTail from '@/vue/atoms/spinner-tail.vue';

/** Configures Quasar plugin defaults for Loading, Notify, and Dialog */
export function getQuasarOptions(): Partial<QuasarPluginOptions> {
  Loading.setDefaults({
    spinner: markRaw(SpinnerTail) as Component,
    spinnerColor: 'primary',
    spinnerSize: 80,
    // backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // message: 'Loading...',
    // messageColor: 'white',
  });
  Notify.setDefaults({
    position: 'top-right',
    textColor: 'white',
    actions: [
      {
        icon: 'close',
        color: 'white',
      },
    ],
  });
  return {
    plugins: {Notify, Loading, Dialog},
    config: {

    },
  };
}
